import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

export const LegalFooterRoot = superstyled({
  name: 'LegalFooter',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    maxWidth: '26.25rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingBlockStart: theme.spacing(1.5),
    paddingInline: theme.spacing(0),
    textAlign: 'center'
  })
});
